import {api} from "./api";
import {MODERATOR_COURSE_LESSON} from "../mock/URLs";
import {GetCourseLessonsResponse, GetLessonByIdResponse} from "../types/lesson";

type GetLessonByIdParams = {
  params: {
    category?: number;
    page_size?: number;
    page?: number
    search?: string;
  }
}

export const getLessonsById = async ({params}: GetLessonByIdParams) => {
  try {
    const {data} = await api.get<GetCourseLessonsResponse>(MODERATOR_COURSE_LESSON, {
      params
    })
    return data
  } catch (e) {
    throw e
  }
}

export const getLessonById = async (id: number) => {
  try {
    const {data} = await api.get<GetLessonByIdResponse>(`${MODERATOR_COURSE_LESSON}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}


export const createLesson = async (formData: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_COURSE_LESSON, formData)
    return data;
  } catch (e) {
    throw e
  }
}


export const updateLesson = async (id:number, formData: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_COURSE_LESSON}${id}/`, formData)
    return data;
  } catch (e) {
    throw e
  }
}